export default "__VITE_ASSET__DNKsG$ny__"